__turbopack_context__.v({
  "ratingDivider": "ReviewCarouselTile-module__m9n4Sa__ratingDivider",
  "reviewSlug": "ReviewCarouselTile-module__m9n4Sa__reviewSlug",
  "reviewsBody": "ReviewCarouselTile-module__m9n4Sa__reviewsBody",
  "reviewsRating": "ReviewCarouselTile-module__m9n4Sa__reviewsRating",
  "subTitle": "ReviewCarouselTile-module__m9n4Sa__subTitle",
  "title": "ReviewCarouselTile-module__m9n4Sa__title",
});
